import type { App } from 'vue'
import { createI18n, I18nOptions } from 'vue-i18n'
import { localeSettings } from '@/settings/locale'
import { importLocaleData, setLoadedLocale, setHTMLElemLang } from './helper'
// import { labelCollectSave } from '@/api/common'
import { useLocaleStoreWithOut } from '@/store-pinia/modules/locale'
// import { useUserStoreWithOut } from '@/store-pinia/modules/user'

const { fallback, availableLocales } = localeSettings

export let i18n: ReturnType<typeof createI18n>
// const loadedLanuages: string[] = []
// const languageKey: any[] = []
// let languageKeyTime: any

async function createOptions(): Promise<I18nOptions> {
  // const store = useStore()
  // const locale = store.getters['locale/LOCALE'] || 'zh_CN'
  const store = useLocaleStoreWithOut()
  const locale = store.getLocale || 'zh_CN'
  const localeData = await importLocaleData(locale)
  const message = localeData?.default?.message ?? {}

  setLoadedLocale(locale)
  setHTMLElemLang(locale)

  return {
    legacy: false,
    locale,
    fallbackLocale: fallback,
    messages: {
      [locale]: message,
    },
    // missing(_locale, key, _vm, _values) {
    //   // console.info('未翻译：', key)
    //   languageKey.unshift(key)
    //   languageKeyTime && clearTimeout(languageKeyTime)
    //   languageKeyTime = setTimeout(() => {
    //     asynclanguage()
    //   }, 1000)
    //   return key
    // },
    availableLocales,
    silentTranslationWarn: true,
    missingWarn: false,
    silentFallbackWarn: true,
    fallbackWarn: false,
  }
}

/**
 * 多语言同步
 */
// const asynclanguage = () => {
//   const userStore = useUserStoreWithOut()
//   if (!userStore.getToken) {
//     return
//   }

//   const temp: any[] = []
//   let key
//   while ((key = languageKey.shift())) {
//     temp.push(key)
//   }
//   if (temp.length) {
//     const store = useLocaleStoreWithOut()
//     const locale = store.getLocale || 'zh_CN'
//     labelCollectSave({
//       labelCodeList: [...new Set(temp)],
//       langCode: locale,
//     })
//   }
// }

export async function setupI18n(app: App) {
  const options = await createOptions()
  i18n = createI18n(options)
  app.use(i18n)
}
